<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>

    <ng-container *ngIf="consulta">
        <div class="body">
            <ng-container *ngFor="let r of consulta?.registros; let i = index">
                <!-- <h2 class="subtitle subtitle-{{status}}">REGISTRO {{i+1}}</h2> -->
                <ul class="card-list-striped py-1">
                    <li>
                        <span class="text-secondary">ENDEREÇO:</span>
                        <span class="text-uppercase">{{ r?.endereco || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">BAIRRO:</span>
                        <span class="text-uppercase">{{ r?.bairro || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">CEP:</span>
                        <span class="text-uppercase">{{ r?.cep || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">CIDADE:</span>
                        <span class="text-uppercase">{{ r?.cidade || msgNull }}</span>
                    </li>
                </ul>
            </ng-container>
        </div>
    </ng-container>
    
</app-card-consulta>